import HttpClient from '../http/HttpClient';
import { LEAD_SERVICE_HOST, LEAD_API_PREFIX } from '../constants/RestConstants';
import type { PlanMarketValuation } from '../../models/MarketValuationTypes';
import { mapMarketTechnicals } from '../../utils/marketTechnicals';

type ApiEnvelope<T> = { data: T; message?: string; statusCode: number };

function mapValuation(raw: Record<string, unknown>): PlanMarketValuation {
  return {
    planId: raw.planId as string | undefined,
    nseCode: raw.nseCode as string | undefined,
    sharesHeld: Number(raw.sharesHeld ?? 0),
    lastClosePrice: raw.lastClosePrice != null ? Number(raw.lastClosePrice) : null,
    priceAvailable: Boolean(raw.priceAvailable),
    priceFetchedAt: raw.priceFetchedAt as string | undefined,
    investedAmount: Number(raw.investedAmount ?? 0),
    currentValue: Number(raw.currentValue ?? 0),
    unrealizedPnl: Number(raw.unrealizedPnl ?? 0),
    unrealizedPnlPct: raw.unrealizedPnlPct != null ? Number(raw.unrealizedPnlPct) : null,
    partnerCurrentValue: raw.partnerCurrentValue != null ? Number(raw.partnerCurrentValue) : null,
    partnerInvestedAmount: raw.partnerInvestedAmount != null ? Number(raw.partnerInvestedAmount) : null,
    partnerUnrealizedPnl: raw.partnerUnrealizedPnl != null ? Number(raw.partnerUnrealizedPnl) : null,
    technicals: mapMarketTechnicals(raw.technicals as Record<string, unknown> | undefined),
  };
}

export async function getPlanMarketValuation(planId: string): Promise<PlanMarketValuation> {
  const response = await HttpClient.GET({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/capitals/stock-plans/${encodeURIComponent(planId)}/market-valuation`,
  });
  return mapValuation((response.data as ApiEnvelope<Record<string, unknown>>).data);
}
